import { render, staticRenderFns } from "./NormalSingle5.vue?vue&type=template&id=afd79754&"
import script from "./NormalSingle5.vue?vue&type=script&lang=js&"
export * from "./NormalSingle5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports